import { useState } from 'react';
import { api, ErreurApi } from '../api.js';
import { tokens } from '../tokens.js';
import { LifeBuoy, Lock } from 'lucide-react';

// Ecran de login plein ecran. Identifiants Dolibarr.
export function LoginDolibarr({ onLogin }) {
  const [login, setLogin] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [envoiEnCours, setEnvoiEnCours] = useState(false);

  async function soumettre(e) {
    e.preventDefault();
    setErreur('');
    setEnvoiEnCours(true);
    try {
      const rep = await api.post('/auth/login', {
        login: login.trim(),
        mot_de_passe: motDePasse,
      });
      onLogin(rep.utilisateur);
    } catch (err) {
      if (err instanceof ErreurApi) {
        setErreur(err.message);
      } else {
        setErreur('Connexion impossible. Verifie ta connexion internet.');
      }
    } finally {
      setEnvoiEnCours(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: tokens.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 380,
        background: tokens.surface,
        borderRadius: 12,
        border: `1px solid ${tokens.border}`,
        padding: 32,
        boxShadow: '0 4px 24px rgba(107, 63, 160, 0.08)',
      }}>
        <div style={{ textAlign:'center', marginBottom: 28 }}>
          <div style={{
            display:'inline-flex', alignItems:'center', justifyContent:'center',
            width: 56, height: 56,
            background: tokens.accentBg,
            color: tokens.accent,
            borderRadius: '50%',
            marginBottom: 16,
          }}>
            <LifeBuoy size={28} />
          </div>
          <h1 style={{
            margin: 0, fontSize: 22, fontWeight: 600, color: tokens.ink,
          }}>
            Tickets AMC
          </h1>
          <p style={{
            marginTop: 6, marginBottom: 0, fontSize: 13, color: tokens.inkSoft,
          }}>
            Connecte-toi avec tes identifiants Dolibarr
          </p>
        </div>

        <form onSubmit={soumettre}>
          <label style={champLabel}>Identifiant Dolibarr</label>
          <input
            type="text"
            value={login}
            onChange={e => setLogin(e.target.value)}
            autoComplete="username"
            autoFocus
            required
            style={champInput}
          />

          <label style={{ ...champLabel, marginTop: 16 }}>Mot de passe</label>
          <input
            type="password"
            value={motDePasse}
            onChange={e => setMotDePasse(e.target.value)}
            autoComplete="current-password"
            required
            style={champInput}
          />

          {erreur && (
            <div style={{
              marginTop: 14, padding: '10px 12px',
              background: tokens.dangerBg,
              color: tokens.danger,
              borderRadius: 6,
              fontSize: 13,
            }}>
              {erreur}
            </div>
          )}

          <button
            type="submit"
            disabled={envoiEnCours}
            style={{
              marginTop: 22, width: '100%',
              padding: '11px',
              background: tokens.accent,
              color: 'white',
              border: 'none',
              borderRadius: 8,
              fontSize: 14, fontWeight: 600,
              display:'flex', alignItems:'center', justifyContent:'center', gap: 8,
              opacity: envoiEnCours ? 0.6 : 1,
            }}
          >
            <Lock size={14} /> {envoiEnCours ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <p style={{
          marginTop: 24, marginBottom: 0,
          fontSize: 11, color: tokens.inkMuted,
          textAlign: 'center', lineHeight: 1.5,
        }}>
          Seuls les utilisateurs ayant un compte Dolibarr peuvent se connecter.
          Aucun mot de passe n'est stocké ici.
        </p>
      </div>
    </div>
  );
}

const champLabel = {
  display: 'block',
  fontSize: 12,
  fontWeight: 500,
  color: tokens.inkSoft,
  marginBottom: 6,
};

const champInput = {
  width: '100%',
  padding: '10px 12px',
  border: `1px solid ${tokens.borderStrong}`,
  borderRadius: 6,
  fontSize: 14,
  outline: 'none',
};
